<script setup lang="ts">
import { computed, defineProps } from 'vue';
import { Draft } from '@/dashboard/types/draft';
import DraftFileIcon from '@/dashboard/vue/components/icons/DraftFileIcon.vue';
import { formatBytes } from '../../../../utils/formatBytes';

const props = defineProps<{
  draft: Draft;
}>();

const extension = computed(() => props.draft.name.split('.').pop());
</script>

<template>
  <div class="wrap-anywhere h-full w-full items-center justify-center text-center text-gray-600 laptop:pt-s">
    <div class="mb-xs text-[14px] laptop:mb-s laptop:text-[12px]">{{ formatBytes(draft.draft_size) }} / .{{ extension }}</div>
    <div class="mb-xs flex justify-center laptop:mb-s">
      <div class="relative">
        <draft-file-icon class="h-[77px] w-[56px] drop-shadow-s-hover laptop:h-[88px] laptop:w-[64px]" />
        <div
          class="absolute bottom-[13px] right-zero line-clamp-1 flex h-[17px] max-w-full bg-brand-night-blue px-[4px] text-[12px] text-white dark:text-black"
        >
          .{{ extension }}
        </div>
      </div>
    </div>
    <div class="line-clamp-1 break-words text-[14px] laptop:line-clamp-2">{{ draft.name }}</div>
  </div>
</template>

<style scoped lang="scss"></style>
